import { type MainLayoutData } from 'app/root/types'

export function getRootLoaderData(): MainLayoutData | undefined {
  const rootLoader = window.__remixContext?.state?.loaderData?.root

  return rootLoader
}
